import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserFormService } from '../../../shared/user-form.service';
import { FormsService } from '../../../../shared/forms.service';
import { UserGenericComponent } from '../../../user-generic.component';
import { AdminRequest } from '@builtbybros/al-model';
import { UserService } from '../../../shared/user.service';

@Component({
  selector: 'app-admin-form',
  templateUrl: './admin-form.component.html',
  styleUrls: ['./admin-form.component.scss', '../../../shared/invalid-form.scss'],
  providers: [UserFormService]
})
export class AdminFormComponent extends UserGenericComponent {

  adminForm: FormGroup;
  @Input() userRole;

  constructor(private fb: FormBuilder,
              private formsService: FormsService,
              private userService: UserService
  ) {
    super(formsService);
    this.createFormGroup();
  }

  public createFormGroup() {
    this.adminForm = this.fb.group({});
  }

  compareUserRole(role: number): boolean {
    return (role === 1);
  }

  public getFormGroup(): FormGroup {
    return this.adminForm;
  }

  getForm(): FormGroup {
    return this.adminForm;
  }

  submitForm(userInfo: any, id?: number) {
    let upsert;
    if (id) {
      const admin = new AdminRequest.Update();
      admin.parse(this.adminForm.value);
      admin.parse(userInfo);
      admin.id = id;
      upsert = this.userService.updateAdmin(id, admin);
    } else {
      const admin = new AdminRequest.Create();
      admin.parse(this.adminForm.value);
      admin.parse(userInfo);
      upsert = this.userService.createAdmin(admin);
    }
    return upsert;
  }
}



// WEBPACK FOOTER //
// ./src/app/user/admin/shared/admin-form/admin-form.component.ts